module.exports = __webpack_public_path__ + "img/ordenes_b.e3ae39be.png";